import React, { useEffect, useState } from "react";

import classnames from "classnames";

import "./Checkbox.styles.scss";

export interface CheckboxProps {
  value: boolean;
  onChange?: any;
  name?: string;
  variant?: "mark-square" | "mark-circle" | "dot" | "green-square";
  size?: "small" | "normal";
  label?: string;
  labelPosition?: "right" | "left";
  className?: string;
  disabled?: boolean;
  errors?: string[];
  hidden?: boolean;
  isPrivate?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  value,
  onChange = () => {},
  variant = "mark-square",
  size = "normal",
  labelPosition = "right",
  label,
  className = "",
  name = "check",
  disabled = false,
  errors = [],
  hidden = false,
  isPrivate = false,
  ...props
}) => {
  const [isErrors, setIsErrors] = useState(false);

  useEffect(() => {
    if (errors.length) {
      setIsErrors(true);
    } else {
      setIsErrors(false);
    }
  }, [errors]);

  if (hidden) return null;

  return (
    <>
      <label
        onClick={(e) => e.stopPropagation()}
        className={classnames("checkbox", className, {
          "flex-rowr-fc-fs": labelPosition === "left",
          "flex-row-fs-fs": labelPosition === "right"
        })}
      >
        <div className={`container container--${size} container--${labelPosition}`}>
          {disabled ? null : (
            <input
              onChange={disabled ? () => null : onChange}
              checked={value}
              type="checkbox"
              id={name}
              hidden
              {...props}
            />
          )}
          <label
            className={`inner-element inner-element--${variant}`}
            style={{
              borderColor: isPrivate ? "#BAC7CE" : "none",
              ...(disabled && { backgroundColor: "#e6e9eb" }),
              ...(disabled && { border: "1.4px solid #54656d" })
            }}
            htmlFor={name}
          />
        </div>
        {label ? <span className={classnames("label", `label--${labelPosition}`)}>{label}</span> : null}
      </label>
      {errors.length ? (
        <span className={`text-input__error text-input__error${isErrors ? "--active" : ""}`}>
          {errors?.length && errors?.map((item) => item)}
        </span>
      ) : null}
    </>
  );
};
